import { render, staticRenderFns } from "./ViewCorp.vue?vue&type=template&id=3ae394be&scoped=true&"
import script from "./ViewCorp.vue?vue&type=script&lang=js&"
export * from "./ViewCorp.vue?vue&type=script&lang=js&"
import style0 from "./ViewCorp.vue?vue&type=style&index=0&id=3ae394be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae394be",
  null
  
)

export default component.exports